import React from "react";
import { Button, Checkbox } from "antd";

export class Kmz extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const options = [
            { label: 'Cable troncal', value: 'Cable troncal' },
            { label: 'Cable distribucion', value: 'Cable distribucion' },
            { label: 'Red por construir', value: 'Red por construir' },
            { label: 'CTOs', value: 'CTOs' },
            { label: 'GIS', value: 'GIS' },
            { label: 'Telefonica', value: 'Telefonica' },
            { label: 'Obras propias', value: 'Obras propias' }
        ];
        return (
            <div>
                {/* <div>
                    <input type="file" accept=".kmz" onChange={this.props.handleKmzUpload} />
                </div> */}
                <div>
                    <h4>Preferencias</h4>
                    <Checkbox.Group
                        value={this.props.preferences}
                        onChange={this.props.handlePreferenceChange}
                    >
                        {options.map((option) => (
                            <Checkbox key={option.value} disabled={true} value={option.value} style={{ width: "100%" }}>
                                {option.label}
                            </Checkbox>
                        ))}
                    </Checkbox.Group>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/components/Kmz.jsx